import { IQueryState } from '@/redux/store.interface'

export const queryInitialState = (): IQueryState => ({
  payload: {},
  services: [],
  payloadIsNotEmpty: false,
  executeQueryLoading: false,
  transactionId: 0,
})
